import React, { ReactNode, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../footer/Footer";
import PageTitle from "../pagetitle/PageTitle";
import Scrollbar from "../scrollbar/scrollbar";

interface PageLayoutProps {
  title: string;
  breadcrumb?: string;
  children: ReactNode;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  breadcrumb,
  children,
  className = "",
}) => {
  useEffect(() => {
    document.title = title + " | CLEARITH";
  }, [title]);

  return (
    <div className={"clearith-site inner-page " + className}>
      <div className="body_wrap o-clip">
        <Header />
        <main>
          <PageTitle pageTitle={title} pagesub={breadcrumb || title} />
          {children}
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </div>
  );
};

export default PageLayout;
